module.exports = __webpack_public_path__ + "static/media/TradeGothic.bd0c25b2.woff";